import _ from 'lodash';
export default (function (logger, Sentry) { return function (params, next) {
    try {
        logger(params);
    }
    catch (err) {
        Sentry.captureException(err);
    }
    if (_.isFunction(next)) {
        return next();
    }
}; });
//# sourceMappingURL=withBIFactory.js.map